import { IFetchAction } from "../../middleware/fetch-middleware";

export enum ApiSearchActions {
    GetSearchContexts = 'apiSearchActions/getSearchContexts',
}

const BaseUrl = '/api/v1/search';

export const getSearchContexts = (): IFetchAction => ({
    type: ApiSearchActions.GetSearchContexts,
    fetch: new Request(`${BaseUrl}/advanced/contexts`)
})